import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCheckboxValue,
  UniversalFilterCheckboxOnChange
} from './UniversalFilterCheckbox.types';

import { useUniversalFilterCheckbox } from './hooks/useUniversalFilterCheckbox';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';
import { UniversalFilterCheckboxInput } from '../../helpers/UniversalFilterCheckboxInput';

interface UniversalFilterCheckboxProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCheckboxValue;
  i18nName: I18nText;
  onChange: UniversalFilterCheckboxOnChange;
}

function UniversalFilterCheckbox({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  onChange
}: UniversalFilterCheckboxProps) {
  const { filterState, handleCheckboxInputChange } = useUniversalFilterCheckbox(
    { filterStateCacheKey, filterValue, onChange }
  );

  return (
    <UniversalFilterTemplate
      filterView={filterView}
      i18nName={i18nName}
      className="flex gap-x-2"
    >
      <UniversalFilterCheckboxInput
        value={filterState?.value}
        onChange={handleCheckboxInputChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCheckbox;
